// @deprecated
// Legacy component : to deprecate
import React from 'react';
import classNames from 'classnames';
import Nullable from '@/types/nullable';

type Props = {
  imgUrl?: Nullable<string>;
  onClick?: () => void;
};

const UploadImageIcon = ({ imgUrl, onClick, ...rest }: Props) => (
  <div onClick={onClick} className={classNames('upload-image-icon d-flex flex-column justify-content-center align-items-center', { 'no-img': !imgUrl })}>
    {imgUrl ? <img src={imgUrl} alt="" /> : <i className="icon-upload" />}
  </div>
);

export default UploadImageIcon;
